import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core'

@Component({
  selector: 'mopinion',
  template: `
    <div>
      <div #script style.display="none">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})

export class Mopinion implements AfterViewInit {

  @Input('formId') formId: string;

  @ViewChild('script', { static: false }) script: ElementRef;

  convertToScript() {
    const element = this.script.nativeElement;
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.innerHTML = `
      (function(){var id="${this.formId}";var js=document.createElement("script");js.setAttribute("type","text/javascript");js.setAttribute("src","//deploy.mopinion.com/js/pastease.js");js.async=true;document.getElementsByTagName("head")[0].appendChild(js);var t=setInterval(function(){try{new Pastease.load(id);clearInterval(t)}catch(e){}},50)})();
    `;

    element.parentElement.parentElement.appendChild(script);
  }

  ngAfterViewInit() {
    this.convertToScript();
  }

}